import React, { useState, Fragment } from 'react';
import { Button, IconButton, CircularProgress } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

import FileUploader from '../../../component/FileUploader';

import API from '../../../config/api';

const FILEKEY = 'b3_blueprint';

const AttachmentBox = ({ loading, onViewFile, onDeleteFile }) => (
	<div className='simple-attachment__box'>
		<div className='attachment__box--header'>
			<div className='left-content'>
				<h5>
					<CheckCircleIcon color='primary' />
					File uploaded
				</h5>
				<Button color='primary' className='view-button' startIcon={<VisibilityIcon color='primary' />} onClick={onViewFile} disableRipple>
					View file
				</Button>
			</div>
			{!loading ? (
				<IconButton color='secondary' size='small' title='Remove file' onClick={onDeleteFile}>
					<DeleteForeverIcon />
				</IconButton>
			) : (
				<CircularProgress size={18} />
			)}
		</div>
	</div>
);

const Uploader = ({ applicationId, token, disabled, onChange }) => (
	<FileUploader id={FILEKEY} token={token} applicationId={applicationId} fileKey={FILEKEY} onChange={onChange} disabled={disabled} fullWidth />
);

const B3BlueprintFile = ({ applicationId, token, disabled, files }) => {
	const [loading, setLoading] = useState(false);
	const [uploaded, setUploaded] = useState(files.b3_blueprint);

	const handleChange = (file) => setUploaded(true);

	const handleViewFile = () => {
		const data = { applicationId, fileKey: FILEKEY };

		const viewFile = window.open();

		API.GetDownloadFileUrl(token, data).then((res) => {
			viewFile.location.href = res.data;
			viewFile.focus();
		});
	};

	const handleDeleteFile = () => {
		setLoading(true);

		API.DeleteFile(token, { applicationId, fileKey: FILEKEY }).then((res) => {
			setUploaded(false);
			setLoading(false);
		});
	};

	return (
		<Fragment>
			{!uploaded ? (
				<Uploader applicationId={applicationId} token={token} disabled={disabled} onChange={handleChange} />
			) : (
				<AttachmentBox loading={loading} onViewFile={handleViewFile} onDeleteFile={handleDeleteFile} />
			)}
		</Fragment>
	);
};

export default B3BlueprintFile;
